import { LocalserverStatusReportsResponse } from "api/queries/MillsAPI";
import moment from "moment";

export const processStatusReports = (
    reports: LocalserverStatusReportsResponse["local_server_status_reports"],
    rangeStartDate: Date,
    rangeEndDate: Date,
) => {
    const startRange = moment(rangeStartDate);
    const endRange = moment(rangeEndDate);

    return reports.map((report) => {
        const processedReport = { ...report };

        const startDate = moment(processedReport.start_date);
        const endDate = processedReport.end_date ? moment(processedReport.end_date) : null;

        if (startDate.isBefore(startRange)) {
            processedReport.start_date = startRange.toDate();
        }
        const effectiveStart = moment(processedReport.start_date);

        if (!endDate) {
            processedReport.duration_in_seconds = endRange.diff(effectiveStart, "seconds");
        } else if (endDate.isAfter(endRange)) {
            processedReport.end_date = endRange.toDate();
            processedReport.duration_in_seconds = endRange.diff(effectiveStart, "seconds");
        } else {
            const effectiveEnd = moment(processedReport.end_date);
            processedReport.duration_in_seconds = effectiveEnd.diff(effectiveStart, "seconds");
        }

        return processedReport;
    });
};
